import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRefresh } from '@fortawesome/free-solid-svg-icons'
import {
  StandardButton,
  StandardButtonSize,
  StandardButtonVariant,
} from './StandardButton'

export const RefreshButton = ({
  onClick,
  isRefreshing,
}: {
  onClick: () => void
  isRefreshing: boolean
}): JSX.Element => (
  <StandardButton
    type="button"
    variant={StandardButtonVariant.SECONDARY}
    buttonSize={StandardButtonSize.SMALL}
    onClick={onClick}
    disabled={isRefreshing}
  >
    <FontAwesomeIcon icon={faRefresh} spin={isRefreshing} />
    Refresh
  </StandardButton>
)
